import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Header, Aside } from "../components";
import { useNavigate } from "react-router-dom";
import { socket } from "../redux/config/socket";
import { notify } from "../helpers/helper";
import { getAccount } from "../redux/action/auth";
import { getOrganization } from "../redux/action/organization";
import {
  DriverAssignedToast,
  PriceChangeToast,
  PriceCounterToast
} from "../components/CustomToast";
import { toast } from "react-toastify";
import {
  getNotifications,
  getNotificationsProfile
} from "../redux/action/notifications";
import { getContracts } from "../redux/action/contracts";
import { getAllScraps } from "../redux/action/scraps";

function Frame({ children, userInfo }) {
  const [openAside, setOpenAside] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!localStorage.getItem("__wasteknot")) return navigate("/");
    dispatch(getAccount());
    dispatch(getOrganization());
    dispatch(getNotificationsProfile());
    dispatch(getAllScraps());
  }, [dispatch, navigate]);

  useEffect(() => {
    socket.on("notification", (msg) => {
      notify({
        title: msg.title,
        body: msg.body
      });
      dispatch(getNotificationsProfile());
      dispatch(getNotifications());
    });
  }, [dispatch]);

  useEffect(() => {
    socket.on("pickup-assigned", (msg) => {
      toast(<DriverAssignedToast notification={msg} />, {
        position: toast.POSITION.BOTTOM_LEFT,
        autoClose: false,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        toastId: "custom-toast"
      });
      dispatch(getNotificationsProfile());
      dispatch(getNotifications());
    });
  }, [dispatch]);

  useEffect(() => {
    socket.on("price-change-requested", (msg) => {
      toast(<PriceChangeToast notification={msg} />, {
        position: toast.POSITION.BOTTOM_LEFT,
        autoClose: false,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined
      });
      dispatch(getContracts());
    });

    socket.on("price-change-counter", (msg) => {
      toast(<PriceCounterToast notification={msg} />, {
        position: toast.POSITION.BOTTOM_LEFT,
        autoClose: false,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined
      });
      dispatch(getContracts());
    });

    socket.on("price-change-accepted", (msg) => {
      notify({
        title: msg.title,
        body: msg.body
      });
      dispatch(getContracts());
    });
  }, [dispatch]);

  return (
    <div className="full-frame">
      <Header
        setOpenAside={setOpenAside}
        openAside={openAside}
        userInfo={userInfo}
      />
      <div className="overlay">
        <Aside openAside={openAside} setOpenAside={setOpenAside} />
        <section className={openAside ? "opne-asid" : ""}>{children}</section>
      </div>
    </div>
  );
}

export default Frame;
